import { render, staticRenderFns } from "./RegrasPagamentoEditar.vue?vue&type=template&id=c77a6854&"
import script from "./RegrasPagamentoEditar.vue?vue&type=script&lang=js&"
export * from "./RegrasPagamentoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports